// extracted by mini-css-extract-plugin
export default {"form":"ProductReviewModal_form__YlsoM","rating":"ProductReviewModal_rating__unLYN","textField":"ProductReviewModal_textField__fvAJF"};